export default __webpack_public_path__ + "static/histogram-with-specified-bins-3c734ade5ccaffa4f6d29c453774594e.png";